import { render, staticRenderFns } from "./SportRoute.vue?vue&type=template&id=d3c91e82&scoped=true&"
import script from "./SportRoute.vue?vue&type=script&lang=js&"
export * from "./SportRoute.vue?vue&type=script&lang=js&"
import style0 from "./SportRoute.vue?vue&type=style&index=0&id=d3c91e82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c91e82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VBtn,VContainer,VDataTable,VIcon,VPagination})
